import { createPortal } from "react-dom";
import { Loader } from "./Loader";
import { Button } from "./Button";
import { CloseIcon } from "./Icons";

const FullScreenLoader = ({
  label,
  isBlur = false,
  showCloseButton = false,
  onClose = () => {},
}: {
  label?: string;
  isBlur?: boolean;
  showCloseButton?: boolean;
  onClose?: () => void;
}) => {
  const loadingPortal = createPortal(
    <div className="fixed inset-0 z-50 h-full w-full">
      {showCloseButton && (
        <div className="absolute right-12 top-12 z-[52]">
          <Button noBg={true} icon={<CloseIcon />} onClick={onClose} />
        </div>
      )}
      <Loader label={label} isBackgroundBlurred={isBlur} />
    </div>,
    document.body,
  );

  return loadingPortal;
};

export default FullScreenLoader;
